module.exports = __webpack_public_path__ + "img/escrow.f033f4d6.svg";